/**
 * Strip the ENSTRU code prefix from a property ID for display purposes.
 *
 * Property IDs in the search index are prefixed with a 9-digit ENSTRU code
 * followed by double underscore, e.g. "203012550__non_volatile_content".
 * This function returns just the property key part ("non_volatile_content").
 *
 * If the ID doesn't match the expected pattern, it is returned as-is.
 */
export function stripEnstruPrefix(propertyId: string): string {
  return propertyId.replace(/^\d{9}__/, '');
}
